// extracted by mini-css-extract-plugin
export var bubble = "_1n-0";
export var container = "_1n-3";
export var contrastBorder = "_1n-4";
export var greyOut = "_1n-2";
export var initialsWrapper = "_1n-1";
export var large = "_1n-9";
export var medium = "_1n-8";
export var mediumSmall = "_1n-7";
export var mediumSmallMedium = "_1n-c";
export var micro = "_1n-5";
export var small = "_1n-6";
export var tiny = "_1n-b";
export var xTiny = "_1n-a";